import { Directive, ElementRef, Input, AfterViewInit } from "@angular/core";

@Directive({
  selector: '[collapseble]'
})
export class CollapsebleDirective implements AfterViewInit {

  @Input() control: string
  @Input() collapsed: boolean = false

  private _control: Element
  private _toggle
  private _height: string

  constructor(private el: ElementRef) { }

  ngAfterViewInit(): void {
    this._height = this.el.nativeElement.clientHeight + 'px'
    this.el.nativeElement.style.height = this.collapsed ? 0 : this._height
    this.el.nativeElement.classList.add('collapseble-animated')
    this._control = document.querySelector(this.control)
    if (this.collapsed) {
      this._control.classList.toggle('collapsed')
    }
    if (this._control) {
      this._toggle = this.toggle.bind(this)
      this._control.addEventListener('click', this._toggle)
    }
  }

  toggle(event: Event) {
    this.collapsed = !this.collapsed
    this.el.nativeElement.style.height = this.collapsed ? 0 : this._height
    this._control.classList.toggle('collapsed')
  }

  ngOnDestroy() {
    this._control.removeEventListener('click', this._toggle)
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/directives/collapseble.directive.ts